import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ListComponent } from 'src/app/common/component/list.component';

@Component({
	selector: 'app-drivers-documents-list',
	templateUrl: './drivers-documents-list.component.html',
	styleUrls: ['./drivers-documents-list.component.css'],
})
export class DriversDocumentsListComponent extends ListComponent implements AfterViewInit {
	@ViewChild(MatSort) sort: MatSort;
	@ViewChild(MatPaginator) paginator: MatPaginator;
	protected apiUrl = 'driverDocuments';
	protected itemsBeforeDataLoad = 2;
	protected filterValue = '';

	displayedColumns: string[] = ['driver', 'kind', 'date'];
	matData = new MatTableDataSource<any>();
	data: Array<object>;

	showTable = true;

	filters;
	parameters = {
		drivers: [],
		documentKinds: [],
	};

	ngAfterViewInit(): void {
		this.matData.sort = this.sort;
		this.matData.paginator = this.paginator;
	}

	protected loadBefore(): void {
		this.api.get('/drivers', (result, error) => {
			this.parameters.drivers = result.data;
			this.loadData();
		});
		this.api.get('/driverDocumentKinds', (result, error) => {
			this.parameters.documentKinds = result.data;
			this.loadData();
		});
	}

	refreshFilter() {
		if (this.filterValue.length < 3 && this.filterValue.length > 0) {
			return;
		}
		this.matData.filter = this.filterValue.trim().toLowerCase();
	}

	protected convertData(data) {
		this.matData.data = data.map((item) => {
			const driverName = this.parameters.drivers.find((objfind) => objfind.id === item.driver);
			item.driver = driverName ? driverName.name : '';
			const documentKind = this.parameters.documentKinds.find((objfind) => objfind.id === item.kind);
			item.kind = documentKind ? documentKind.kind : '';
			return item;
		});
	}
}
